import { useEffect, useState } from 'react'

export function useDebouncedValue<T>(value: T, delayMs: number) {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const handle = setTimeout(() => setDebouncedValue(value), delayMs)
    return () => clearTimeout(handle)
  }, [value, delayMs])

  return debouncedValue
}
